<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-money-check-alt"></i> Credit Notes
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <CreditNoteDataTable>
          <template v-slot:title>
            <h3>Credit Notes List</h3>
          </template>
          <template v-slot:tools>
            <ActionButton type="new" v-if="userHasCreatePermission(PermissionTypes.AccountsPermissionTypes.creditNote)" @click="addCreditNote" sizeClass="btn"> Add Credit Note</ActionButton>
          </template>
        </CreditNoteDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import CreditNoteDataTable from '@/modules/accounts/components/creditNoteDataTable'
import AddCreditNoteDialog from '@/modules/accounts/views/addCreditNoteDialog'

export default {
  name: 'CreditNoteList',
  components: {
    CreditNoteDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {
    addCreditNote() {
      this.displayModal(AddCreditNoteDialog)
      .then((creditNoteId) => {
        if(creditNoteId) {
          this.successToast('Credit Note Created')
          this.$router.push(`/accounts/creditnotes/${creditNoteId}`)
        }
      })
    }
  }
};
</script>
